import { createFileRoute } from "@tanstack/react-router";
import { BucketCheckoutPage } from "../../../features/bucket/pages/bucket-checkout-page";

export const Route = createFileRoute("/$lang/_layout/bucket/checkout")({
  component: BucketCheckoutPage,
});
